import { BatchSearchRequest, BatchSearchResponse, BatchEventEntity, BatchDocumentsResponse } from "./types";
import Configuration from "../../config/einvoicing-configuration";

// Set to true to use mock data (when backend is not running)
// Set to false to call the real API endpoints
const USE_MOCK_DATA = false;

const API_BASE = `${Configuration.eventServiceUrl}/dashboard`;

// ============================================================
// MOCK DATA — Remove when backend is connected (Phase 7.5b)
// ============================================================
const MOCK_BATCHES: BatchEventEntity[] = [
  {
    id: "batch-001",
    batchId: "a4f2ed08-2f71-4bbb-b3a1-1a2b3c4d5e6f",
    partitionKey: "FR_1073_Default_SalesReport",
    countryCode: "FR",
    companyCode: "1073",
    mode: "Default",
    documentType: "Invoice",
    configType: "SalesReport",
    status: "Completed",
    documentCount: 842,
    reportPeriodStart: "2026-02-01T00:00:00Z",
    reportPeriodEnd: "2026-02-10T23:59:59Z",
    createdDateTime: "2026-02-01T00:15:00Z",
    sentDateTime: "2026-02-11T00:05:12Z",
    completedDateTime: "2026-02-11T01:30:05Z",
    retryCount: 0,
    bufferExpiryDateTime: null,
    batchEvents: [
      { category: "BatchCreated", timestamp: "2026-02-01T00:15:00Z", message: "Batch created for period Feb 1-10" },
      { category: "BatchDocumentStaged", timestamp: "2026-02-10T23:59:00Z", message: "842 documents staged" },
      { category: "BatchReadyToSend", timestamp: "2026-02-11T00:05:00Z", message: "Buffer expired, batch ready to send" },
      { category: "BatchSent", timestamp: "2026-02-11T00:05:12Z", message: "Sent to Edicom" },
      { category: "BatchCallbackReceived", timestamp: "2026-02-11T01:30:00Z", message: "Callback received from Edicom" },
      { category: "BatchCompleted", timestamp: "2026-02-11T01:30:05Z", message: "842/842 documents completed" },
    ],
    errors: [],
  },
  {
    id: "batch-002",
    batchId: "1d9ab8c3-4e56-7890-abcd-ef1234567890",
    partitionKey: "FR_1073_Default_SalesReport",
    countryCode: "FR",
    companyCode: "1073",
    mode: "Default",
    documentType: "Invoice",
    configType: "SalesReport",
    status: "Staging",
    documentCount: 156,
    reportPeriodStart: "2026-02-11T00:00:00Z",
    reportPeriodEnd: "2026-02-20T23:59:59Z",
    createdDateTime: "2026-02-11T00:30:00Z",
    sentDateTime: null,
    completedDateTime: null,
    retryCount: 0,
    bufferExpiryDateTime: null,
    batchEvents: [
      { category: "BatchCreated", timestamp: "2026-02-11T00:30:00Z", message: "Batch created for period Feb 11-20" },
      { category: "BatchDocumentStaged", timestamp: "2026-02-15T14:00:00Z", message: "156 documents staged so far" },
    ],
    errors: [],
  },
  {
    id: "batch-003",
    batchId: "b31c2f45-6789-0abc-def1-234567890abc",
    partitionKey: "TW_partner-guid-001_Default_Standard",
    countryCode: "TW",
    companyCode: "1000",
    mode: "Default",
    documentType: "Invoice",
    configType: "Standard",
    status: "Sent",
    documentCount: 456,
    reportPeriodStart: null,
    reportPeriodEnd: null,
    createdDateTime: "2026-02-10T08:00:00Z",
    sentDateTime: "2026-02-11T08:00:05Z",
    completedDateTime: null,
    retryCount: 0,
    bufferExpiryDateTime: null,
    batchEvents: [
      { category: "BatchCreated", timestamp: "2026-02-10T08:00:00Z", message: "Batch created" },
      { category: "BatchDocumentStaged", timestamp: "2026-02-11T07:55:00Z", message: "456 documents staged" },
      { category: "BatchReadyToSend", timestamp: "2026-02-11T08:00:00Z", message: "Time trigger elapsed, no gaps" },
      { category: "BatchSent", timestamp: "2026-02-11T08:00:05Z", message: "Sent to FMP/Pagero" },
    ],
    errors: [],
  },
  {
    id: "batch-004",
    batchId: "64803b81-2057-474d-9a8e-f1234567890d",
    partitionKey: "FR_1073_Default_PaymentReport",
    countryCode: "FR",
    companyCode: "1073",
    mode: "Default",
    documentType: "PaymentReceipt",
    configType: "PaymentReport",
    status: "Failed",
    documentCount: 3200,
    reportPeriodStart: "2026-01-01T00:00:00Z",
    reportPeriodEnd: "2026-01-31T23:59:59Z",
    createdDateTime: "2026-01-01T00:10:00Z",
    sentDateTime: null,
    completedDateTime: null,
    retryCount: 5,
    bufferExpiryDateTime: null,
    batchEvents: [
      { category: "BatchCreated", timestamp: "2026-01-01T00:10:00Z", message: "Batch created for Jan payment report" },
      { category: "BatchDocumentStaged", timestamp: "2026-01-31T23:50:00Z", message: "3200 documents staged" },
      { category: "BatchReadyToSend", timestamp: "2026-02-01T00:05:00Z", message: "Month-end trigger, buffer expired" },
      { category: "BatchFailed", timestamp: "2026-02-01T00:20:12Z", message: "Max retries exceeded (5/5)" },
    ],
    errors: [
      { attempt: 1, timestamp: "2026-02-01T00:05:12Z", httpStatusCode: 500, errorMessage: "Internal Server Error" },
      { attempt: 2, timestamp: "2026-02-01T00:06:12Z", httpStatusCode: 500, errorMessage: "Internal Server Error" },
      { attempt: 3, timestamp: "2026-02-01T00:08:12Z", httpStatusCode: 503, errorMessage: "Service Unavailable" },
      { attempt: 4, timestamp: "2026-02-01T00:12:12Z", httpStatusCode: 503, errorMessage: "Service Unavailable" },
      { attempt: 5, timestamp: "2026-02-01T00:20:12Z", httpStatusCode: 503, errorMessage: "Max retries exceeded" },
    ],
  },
  {
    id: "batch-005",
    batchId: "f47f1d92-3456-789a-bcde-f01234567890",
    partitionKey: "TW_partner-guid-002_Default_Standard",
    countryCode: "TW",
    companyCode: "1000",
    mode: "Default",
    documentType: "Invoice",
    configType: "Standard",
    status: "ReadyToSend",
    documentCount: 1000,
    reportPeriodStart: null,
    reportPeriodEnd: null,
    createdDateTime: "2026-02-11T10:00:00Z",
    sentDateTime: null,
    completedDateTime: null,
    retryCount: 0,
    bufferExpiryDateTime: null,
    batchEvents: [
      { category: "BatchCreated", timestamp: "2026-02-11T10:00:00Z", message: "Batch created" },
      { category: "BatchDocumentStaged", timestamp: "2026-02-12T09:30:00Z", message: "1000 documents staged" },
      { category: "BatchReadyToSend", timestamp: "2026-02-12T09:30:01Z", message: "Size trigger: 1000/1000 documents" },
    ],
    errors: [],
  },
  {
    id: "batch-006",
    batchId: "9c12ab34-5678-9def-0123-456789abcdef",
    partitionKey: "FR_1073_Default_PaymentReport",
    countryCode: "FR",
    companyCode: "1073",
    mode: "Default",
    documentType: "PaymentReceipt",
    configType: "PaymentReport",
    status: "Staging",
    documentCount: 45,
    reportPeriodStart: "2026-02-01T00:00:00Z",
    reportPeriodEnd: "2026-02-28T23:59:59Z",
    createdDateTime: "2026-02-01T00:20:00Z",
    sentDateTime: null,
    completedDateTime: null,
    retryCount: 0,
    bufferExpiryDateTime: null,
    batchEvents: [
      { category: "BatchCreated", timestamp: "2026-02-01T00:20:00Z", message: "Batch created for Feb payment report" },
      { category: "BatchDocumentStaged", timestamp: "2026-02-15T12:00:00Z", message: "45 documents staged so far" },
    ],
    errors: [],
  },
  {
    id: "batch-007",
    batchId: "2e3f4a5b-6c7d-8e9f-0a1b-2c3d4e5f6a7b",
    partitionKey: "TW_partner-guid-001_UAT_Standard",
    countryCode: "TW",
    companyCode: "1000",
    mode: "UAT",
    documentType: "Invoice",
    configType: "Standard",
    status: "Completed",
    documentCount: 50,
    reportPeriodStart: null,
    reportPeriodEnd: null,
    createdDateTime: "2026-02-05T14:00:00Z",
    sentDateTime: "2026-02-06T14:00:05Z",
    completedDateTime: "2026-02-06T15:30:00Z",
    retryCount: 0,
    bufferExpiryDateTime: null,
    batchEvents: [
      { category: "BatchCreated", timestamp: "2026-02-05T14:00:00Z", message: "UAT batch created" },
      { category: "BatchDocumentStaged", timestamp: "2026-02-06T13:55:00Z", message: "50 documents staged" },
      { category: "BatchReadyToSend", timestamp: "2026-02-06T14:00:00Z", message: "Time trigger elapsed" },
      { category: "BatchSent", timestamp: "2026-02-06T14:00:05Z", message: "Sent to FMP/Pagero" },
      { category: "BatchCallbackReceived", timestamp: "2026-02-06T15:29:55Z", message: "Callback received" },
      { category: "BatchCompleted", timestamp: "2026-02-06T15:30:00Z", message: "50/50 documents completed" },
    ],
    errors: [],
  },
];

function getMockSearchResponse(): BatchSearchResponse {
  const countByField = (field: keyof BatchEventEntity) => {
    const counts: Record<string, number> = {};
    MOCK_BATCHES.forEach((b) => {
      const val = String(b[field]);
      counts[val] = (counts[val] || 0) + 1;
    });
    return Object.entries(counts).map(([value, count]) => ({ value, count }));
  };
  return {
    totalCount: MOCK_BATCHES.length,
    batches: MOCK_BATCHES,
    facets: {
      status: countByField("status"),
      configType: countByField("configType"),
      countryCode: countByField("countryCode"),
      companyCode: countByField("companyCode"),
      documentType: countByField("documentType"),
      mode: countByField("mode"),
    },
  };
}

function getMockDocuments(batchId: string, partitionKey: string, skip: number): BatchDocumentsResponse {
  const batch = MOCK_BATCHES.find((b) => b.batchId === batchId);
  const total = batch?.documentCount || 25;
  const docs = [];
  for (let i = 0; i < Math.min(25, total - skip); i++) {
    const seq = skip + i + 1;
    docs.push({
      id: `${batchId}_DOC-${String(seq).padStart(5, "0")}`,
      partitionKey,
      batchId,
      documentId: `DOC-${String(seq).padStart(5, "0")}`,
      partnerId: "partner-001",
      requestId: `REQ-${String(seq).padStart(5, "0")}`,
      sequenceId: seq,
      stagedDateTime: new Date(Date.now() - (total - seq) * 60000).toISOString(),
    });
  }
  return { totalCount: total, documents: docs };
}

// ============================================================
// API FUNCTIONS
// ============================================================

export async function searchBatches(request: BatchSearchRequest, accessToken: string): Promise<BatchSearchResponse> {
  if (USE_MOCK_DATA) {
    return Promise.resolve(getMockSearchResponse());
  }
  const response = await fetch(`${API_BASE}/SearchBatches`, {
    method: "POST",
    headers: { "Content-Type": "application/json", "Authorization": `Bearer ${accessToken}` },
    body: JSON.stringify(request),
  });
  if (!response.ok) {
    throw new Error(`SearchBatches failed: ${response.status}`);
  }
  return response.json();
}

export async function getBatchEvents(batchId: string, partitionKey: string, accessToken: string): Promise<BatchEventEntity> {
  if (USE_MOCK_DATA) {
    const batch = MOCK_BATCHES.find((b) => b.batchId === batchId);
    if (!batch) throw new Error(`Batch ${batchId} not found`);
    return Promise.resolve(batch);
  }
  const response = await fetch(`${API_BASE}/GetBatchEvents/${encodeURIComponent(batchId)}/${encodeURIComponent(partitionKey)}`, {
    headers: { "Authorization": `Bearer ${accessToken}` },
  });
  if (!response.ok) {
    throw new Error(`GetBatchEvents failed: ${response.status}`);
  }
  return response.json();
}

export async function getBatchDocuments(batchId: string, partitionKey: string, accessToken: string, skip = 0, pageSize = 25): Promise<BatchDocumentsResponse> {
  if (USE_MOCK_DATA) {
    return Promise.resolve(getMockDocuments(batchId, partitionKey, skip));
  }
  const response = await fetch(`${API_BASE}/GetBatchDocuments/${encodeURIComponent(batchId)}/${encodeURIComponent(partitionKey)}?skip=${skip}&pageSize=${pageSize}`, {
    headers: { "Authorization": `Bearer ${accessToken}` },
  });
  if (!response.ok) {
    throw new Error(`GetBatchDocuments failed: ${response.status}`);
  }
  return response.json();
}

export async function getBatchFailedDocuments(batchId: string, partitionKey: string, accessToken: string, skip = 0, pageSize = 25): Promise<BatchDocumentsResponse> {
  const response = await fetch(`${API_BASE}/GetBatchFailedDocuments/${encodeURIComponent(batchId)}/${encodeURIComponent(partitionKey)}?skip=${skip}&pageSize=${pageSize}`, {
    headers: { "Authorization": `Bearer ${accessToken}` },
  });
  if (!response.ok) {
    throw new Error(`GetBatchFailedDocuments failed: ${response.status}`);
  }
  return response.json();
}

export async function downloadBatchDocuments(batchId: string, partitionKey: string, accessToken: string, countryCode?: string, companyCode?: string, configType?: string): Promise<void> {
  if (USE_MOCK_DATA) {
    alert("Download Documents: This will download all documents as a single JSON file when connected to the backend API.");
    return;
  }
  const response = await fetch(`${API_BASE}/DownloadBatchDocuments/${encodeURIComponent(batchId)}/${encodeURIComponent(partitionKey)}`, {
    headers: { "Authorization": `Bearer ${accessToken}` },
  });
  if (!response.ok) {
    throw new Error(`DownloadBatchDocuments failed: ${response.status}`);
  }
  const blob = await response.blob();
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `${countryCode ?? "XX"}_${companyCode ?? "0000"}_${configType ?? "batch"}_${batchId}_Documents.json`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
}

export async function downloadBatchInvalidDocuments(batchId: string, partitionKey: string, accessToken: string, countryCode?: string, companyCode?: string, configType?: string): Promise<void> {
  if (USE_MOCK_DATA) {
    alert("Download Invalid Documents: This will download the skipped/invalid documents (with failure stage and reason) as a JSON file when connected to the backend API.");
    return;
  }
  const response = await fetch(`${API_BASE}/DownloadBatchInvalidDocuments/${encodeURIComponent(batchId)}/${encodeURIComponent(partitionKey)}`, {
    headers: { "Authorization": `Bearer ${accessToken}` },
  });
  if (!response.ok) {
    throw new Error(`DownloadBatchInvalidDocuments failed: ${response.status}`);
  }
  const blob = await response.blob();
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `${countryCode ?? "XX"}_${companyCode ?? "0000"}_${configType ?? "batch"}_${batchId}_InvalidDocuments.json`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
}

export async function downloadBatchPayload(batchId: string, partitionKey: string, accessToken: string, countryCode?: string, companyCode?: string, configType?: string): Promise<void> {
  if (USE_MOCK_DATA) {
    alert("Download Batch: This will download the batch entity + transformed payload as ZIP when connected to the backend API.");
    return;
  }
  const response = await fetch(`${API_BASE}/DownloadBatchPayload/${encodeURIComponent(batchId)}/${encodeURIComponent(partitionKey)}`, {
    headers: { "Authorization": `Bearer ${accessToken}` },
  });
  if (!response.ok) {
    throw new Error(`DownloadBatchPayload failed: ${response.status}`);
  }
  const blob = await response.blob();
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `${countryCode ?? "XX"}_${companyCode ?? "0000"}_${configType ?? "batch"}_${batchId}.zip`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
}

export async function downloadBatchB2CReport(batchId: string, partitionKey: string, accessToken: string, countryCode?: string, companyCode?: string, configType?: string): Promise<void> {
  if (USE_MOCK_DATA) {
    alert("B2C Report (CSV): This will download a CSV containing only B2C documents (no customer Tax ID) for this batch when connected to the backend API.");
    return;
  }
  const response = await fetch(`${API_BASE}/DownloadBatchB2CReport/${encodeURIComponent(batchId)}/${encodeURIComponent(partitionKey)}`, {
    headers: { "Authorization": `Bearer ${accessToken}` },
  });
  if (!response.ok) {
    throw new Error(`DownloadBatchB2CReport failed: ${response.status}`);
  }
  const blob = await response.blob();
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `${countryCode ?? "XX"}_${companyCode ?? "0000"}_${configType ?? "batch"}_${batchId}_B2CReport.csv`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
}
